/**
 * Validadores E.164 del phone-input provisional.
 * TODO: [NIF-519] Revisar/retirar al migrar al componente de Infinity adaptado.
 */
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import {
	isValidE164,
	isValidNationalNumber,
	normalizeDialPrefix,
	normalizeNationalNumber,
	toE164,
} from '../utils/phone.util';

export function phoneE164Validator(): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {
		const value = control.value;
		if (value == null || value === '') {
			return null;
		}
		return isValidE164(String(value)) ? null : { phoneE164: true };
	};
}

export function phonePartsValidator(): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {
		const prefix = normalizeDialPrefix(control.get('prefix')?.value);
		const number = normalizeNationalNumber(control.get('number')?.value);

		if (!prefix) {
			return { phonePrefixRequired: true };
		}
		if (!number) {
			return { phoneNumberRequired: true };
		}
		if (!isValidNationalNumber(number)) {
			return { phoneNumberInvalid: true };
		}
		if (!toE164(prefix, number)) {
			return { phoneE164: true };
		}
		return null;
	};
}

export function requiredPhoneE164Validator(): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {
		const value = String(control.value ?? '').trim();
		if (!value) {
			return { required: true };
		}
		return isValidE164(value) ? null : { phoneE164: true };
	};
}
